//**************************************************************
// 1. scroll fadein animation
//**************************************************************
$(window).scroll(function () {
  $('.fadeIn, .fadeInUp, .fadeInRight, .fadeInLeft, .fadeInScale').each(function() {
    var elemPos = $(this).offset().top,
      scroll = $(window).scrollTop(),
      windowHeight = $(window).height();

    if (scroll > elemPos - windowHeight + 100) {
      $(this).addClass('scrollin');
    }
  });
});


//**************************************************************
// 2. Scroll ※topを離れたらclass付与
//**************************************************************
function init() {
  // スクロールして何ピクセルでアニメーションさせるか
  var px_change   = 300;

  // スクロールのイベントハンドラを登録　ヘッダーにクラス名 smaller を付与
  window.addEventListener('scroll', function(e){
    // 変化するポイントまでスクロールしたらクラスを追加
    if ( $(window).scrollTop() > px_change ) {
      $('header').addClass('smaller');

      // 変化するポイント以前であればクラスを削除
    } else if ( $('header').hasClass('smaller') ) {
      $('header').removeClass('smaller');
      $('#header-nav').removeAttr('checked').prop('checked', false).change();  // topでpull down用のcheckを外す
    }
  });
}
window.onload = init();

//**************************************************************
// 3. Smooth Scroll （TOPに戻るボタン用）
//**************************************************************
$(function(){
  $('a[href^="#"]').click(function(){
    var speed = 500;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
    $("html, body").animate({scrollTop:position}, speed, 'linear');
    return false;
  });
});


//**************************************************************
// 4. スクロールしたら メニューを隠す
//**************************************************************
var startPos = 0,winScrollTop = 0;
$(window).on('scroll',function(){
  winScrollTop = $(this).scrollTop();
  if (winScrollTop >= startPos) {
    if(winScrollTop >= 200){
      $('.site-header').addClass('hide');
    }
  } else {
    $('.site-header').removeClass('hide');
  }
  startPos = winScrollTop;
});

//**************************************************************
// 5. SLIDE SHOW
//**************************************************************
// 自動フェードインで切り替わるスライドパターン
$(function () {
  ////////// スライドの現在値と最終スライド番号を変数化 //////////
  var slideCurrent = 0; // スライド現在値（1枚目のスライド番号としての意味も含む）
  var lastCurrent = $('.fade-list').length - 1; // スライドの合計数＝最後のスライド番号
  //////// 初期スライドだけ表示 //////////
  $('.fade-list').css('display', 'none'); // 一旦すべてのスライドを非表示
  $('.fade-list').eq(slideCurrent).css('display', 'block'); // 最初のスライドを表示
  ////////// スライドの切り替わりを「changeslide」として定義(ボタンで取得したスライド番号で変化させる) //////////
  function changeslide() {
    $('.fade-list').fadeOut(1000); // 現在のスライドをフェードアウトさせる
    $('.fade-list').eq(slideCurrent).fadeIn(1500); // 次のスライドを表示させる
    //////// 現在のページに合わせてページネーションを変化させる
    var pagiNation = slideCurrent + 1; // nth-of-typeで1枚目もカウントとるためスライド数を修正して変数代入
    // targetクラスを削除
    $('.pagination-circle').removeClass('target');
    // 現在のボタンにtargetクラスを追加
    $(".pagination-circle:nth-of-type(" + pagiNation + ")").addClass('target');
  };
  //////// 自動スライド切り替えのタイマーを設定 //////////
  var Timer;
  // 一定時間毎に処理実行する「startTimer」関数を定義
  function startTimer() {
    Timer = setInterval(function () { // setInterval・・・指定した時間ごとに関数を実行
      if (slideCurrent === lastCurrent) { // 現在のスライドが最終スライドの場合
        slideCurrent = 0;
        changeslide(); // スライド初期値の値を代入して関数実行（初めのスライドに戻す）
      } else {
        slideCurrent++;
        changeslide(); // そうでなければスライド番号を増やして（次のスライドに切り替え）関数実行
      };
    }, 5000); // 上記動作を3秒毎に
  }
  // 「startTimer」関数を止める「stopTimer」関数を定義
  function stopTimer() {
    clearInterval(Timer); // clearInterval・・・setIntervalで設定したタイマーを取り消す
  }
  //////// 自動スライド切り替えタイマーを発動
  startTimer();
  ////////// ボタンを押すとchangeslide関数が発動 //////////
  // NEXTボタン
  $('.js-btn-next').click(function () {
    // 動いているタイマーをストップして再度タイマーを動かし直す（こうしないとページ送り後の時間間隔がズレる）
    stopTimer();
    startTimer();
    if (slideCurrent === lastCurrent) { // 現在のスライドが最終スライドの場合
      slideCurrent = 0;
      changeslide(); // スライド初期値の値を代入して関数実行（初めのスライドに戻す）
    } else {
      slideCurrent++;
      changeslide(); // そうでなければスライド番号を増やして（次のスライドに切り替え）関数実行
    };
  });
  // BACKボタン
  $('.js-btn-back').click(function () {
    // 動いているタイマーをストップして再度タイマーを動かし直す（こうしないとページ送り後の時間間隔がズレる）
    stopTimer();
    startTimer();
    if (slideCurrent === 0) { // 現在のスライドが初期スライドの場合
      slideCurrent = lastCurrent;
      changeslide(); // 最終スライド番号を代入して関数実行（最後のスライドに移動）
    } else {
      slideCurrent--;
      changeslide(); // そうでなければスライド番号を減らして（前のスライドに切り替え）関数実行
    };
  });
});


//**********************************************************************
// 6. ハンバーガーメニューのメニュークリック後に 閉じる
//**********************************************************************
$(function() {
  $('.modal-close').on('click', function(event) {
    $('.global-menu-sp').removeClass('active');
  });
});

$(function() {
  $('.hum-close').on('click', function(event) {
    $('.hamburger').removeClass('active');
  });
});

//**********************************************************************
// 7. ハンバーガーメニューの起動
//**********************************************************************
$(function() {
  $('.hamburger').click(function() {
    $(this).toggleClass('active');

    if ($(this).hasClass('active')) {
      $('.global-menu-sp').addClass('active');
    }
    else {
      $('.global-menu-sp').removeClass('active');
    }
  });
});

//**********************************************************************
// 8. メニューのCurrent表示（現在みているページに.currentを付与する）PC
//**********************************************************************
$(document).ready(function() {
  if(location.pathname != "/") {
    $('.nav-list li a[href^="/' + location.pathname.split("/")[1] + '"]').addClass('current');
  } else $('.nav-list li a:eq(0)').addClass('current');
});

//**********************************************************************
// 9. メニューのCurrent表示（現在みているページに.currentを付与する）SP
//**********************************************************************
$(document).ready(function() {
  if(location.pathname != "/") {
    $('.nav-list-sp li a[href^="/' + location.pathname.split("/")[1] + '"]').addClass('current');
  } else $('.nav-list-sp li a:eq(0)').addClass('current');
});

//**********************************************************************
// PROGRESS CIRCLE
//**********************************************************************

(function($) { "use strict";

$(document).ready(function(){"use strict";

//Scroll back to top

var progressPath = document.querySelector('.progress-wrap path');
var pathLength = progressPath.getTotalLength();
progressPath.style.transition = progressPath.style.WebkitTransition = 'none';
progressPath.style.strokeDasharray = pathLength + ' ' + pathLength;
progressPath.style.strokeDashoffset = pathLength;
progressPath.getBoundingClientRect();
progressPath.style.transition = progressPath.style.WebkitTransition = 'stroke-dashoffset 10ms linear';
var updateProgress = function () {
  var scroll = $(window).scrollTop();
  var height = $(document).height() - $(window).height();
  var progress = pathLength - (scroll * pathLength / height);
  progressPath.style.strokeDashoffset = progress;
}

updateProgress();
$(window).scroll(updateProgress);
var offset = 50;
var duration = 550;
jQuery(window).on('scroll', function() {
  if (jQuery(this).scrollTop() > offset) {
    jQuery('.progress-wrap').addClass('active-progress');
  } else {
    jQuery('.progress-wrap').removeClass('active-progress');
  }
});
jQuery('.progress-wrap').on('click', function(event) {
  event.preventDefault();
  jQuery('html, body').animate({scrollTop: 0}, duration);
  return false;
})


});

})(jQuery);
